import { useQuery } from "@tanstack/react-query";
import { api } from "jiffy-api";
import { objNamesToCamelCase } from "common/utils/helpers/cases";

export function useCanvaDesigns() {
  return useQuery({
    queryKey: ["canvaDesigns"],
    queryFn: () => api.canva.designs().then(objNamesToCamelCase)
  });
}
